import gql from "graphql-tag";
import { Company } from "../baseTypes";
export default gql`
  query ListAllCompanies($name: String, $nextToken: String) {
    listCompanys(
      limit: 100
      nextToken: $nextToken
      filter: {
        and: [{ name: { contains: $name } }, { deactivated: { ne: true } }]
      }
    ) {
      items {
        id
        name
        deactivated
        settings {
          defaultSelfTests
          hasSelfTests
        }
        locations(limit: 500) {
          items {
            companyId
            id
            locationId
            name
          }
        }
      }
      nextToken
    }
  }
`;
export interface ListAllComapniesQuery {
  listCompanys: {
    items: Array<Company> | null;
    nextToken?: string;
  };
}
